module.exports = __webpack_public_path__ + "img/Screenshot_2021-10-28-16-20-12-457_com.pinkcoffee.sexbattle.b5bf934d.jpg";